const getSessionStorage = () => {
  try {
    return sessionStorage
  } catch {
    return undefined
  }
}

export default getSessionStorage
